module.exports = __webpack_public_path__ + "img/fa-brands-400.5bf1455.svg";